<template lang="pug">
main.set-password
  p(v-if='setPasswordMessage') {{ setPasswordMessage }}
  b-form(id='setPassword' role='form' :action='action' method='post' @submit.stop novalidate)
    //- input(name='_csrf' type='hidden' value='{{csrfToken}}')
    .fl-rows
      .fl-row.xs-pr-fl-rows.xs-ld-fl-columns.email.form-group
        label.fl-column.fixed.align-right(for='password') Please enter a password:
        IconedInput.fl-column(id='password' type='password' v-model.trim='form.password' :icon='$icons.lock' required autofocus)

      .fl-row.terms(v-if="showAgreeTerms")
        p-check.p-icon(class="terms" name='terms' color="primary-o" v-model="form.terms" required)
          span By activating your account, you are agreeing to our
            FontAwesomeIcon.icon(:icon='$icons.tick' slot='extra')
        a(:href='$Constants.SaveTrees.Www.TermsOfUse' target='_blank') Terms of Use

    .fl-row.jc-center
      vue-submit.restrict(id='setPasswordSubmit' :running='submitting' @click='submit') Set password
</template>

<script>
import { Form } from "@/utils/Form/Form";
import { validatePassword } from "@timesheets/validators-common";
import "./scss";
import { Signup } from "@timesheets/constants-common";

export default {
  name: "SetPassword",
  extends: Form,
  props: {
    showAgreeTerms: {
      type: Boolean,
    },
    route: {
      type: String,
      required: true,
    },
    newRequest: {
      type: Object,
      required: true,
    },
    setPasswordMessage: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      form: {
        canonicalName: this.$app.currentTenant ? this.$app.currentTenant.branding.names.currentCanonical : "Initialising...",
        terms: undefined,
        password: undefined,
      },
      showNewRequest: false,
    };
  },
  watch: {
    errors() {
      this.$emit("errors", this.errors);
    },
  },
  methods: {
    validate(form, errors) {
      validatePassword(form.password, errors, undefined, this.$options.name, { newPassword: true });
      if (this.showAgreeTerms && !form.terms) {
        errors.push(Signup.Errors.Terms);
      }
    },
    onSuccess(resetPasswordResponse) {
      window.location.assign(resetPasswordResponse.route);
    },
  },
};
</script>
